function init() {
    var adsjs = window.adsjs || {};
    adsjs.gn = adsjs.gn || {};
    adsjs.gn.url = "/api/global-notifications/globalnotifications";

$(function () {

    var nowDt = (new Date()).toISOString();
    var url = `${adsjs.gn.url}?$select=CssClass,Content&$filter=StartDate le ${nowDt} AND EndDate ge ${nowDt}`;

    $.ajax({
        url: url,
        type: 'GET',
        success: function (data) {
            if (data != null && data.value != null && data.value.length > 0) {
                for (var i = 0; i < data.value.length; i++) {
                    var notif = data.value[i];
                    var html = `<div class="section section--full global-notification">
    <div class="${notif.CssClass}">
        <div class="u-flex u-flex--justify-center u-flex--align-items-center">
            <p>
                    ${notif.Content}
            </p>
        </div>
    </div>
</div>`;
                    $("body").prepend(html);
                }
            }
        }
    });

});

}

export {
    init
}